import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useSearchParams, useNavigate } from 'react-router-dom';


  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'İsitmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Davam edən',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'Ventilyasiya',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Tamamlanmış',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'Soyutma',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Davam edən',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'Santexnika',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
        situation: 'Davam edən',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'Yanğınsöndürmə',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
        situation: 'Tamamlanmış',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'Elektrik sistemləri',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
        situation: 'Tamamlanmış',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'Aşağı cərəyan',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
         situation: 'Tamamlanmış',
        },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'Avtomatlaşdırma sistemləri',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
         situation: 'Tamamlanmış',  },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'Kanal sexi',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
        situation: 'Davam edən',
      },
  ];

  
  const ProjectsItems = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
  
    // URL'den filtre durumunu al
    const filterFromURL = searchParams.get('filter') || 'all';
    const [filter, setFilter] = useState(filterFromURL);
  
    // URL'deki filtre değeri değiştiğinde state'i güncelle
    useEffect(() => {
      setFilter(filterFromURL);
    }, [filterFromURL]);
  
    // Filtreleme işlemi
    const filteredItems = newsItems.filter((item) => {
      if (filter === 'all') return true;
      return item.situation === filter;
    });
  
    const handleFilterChange = (value) => {
      setFilter(value);
      setSearchParams({ filter: value });
    };
  
    return (
      <div className="pt-[88px] md:pt-[104px] bg-[#FBFBFB]">
        <div className="max-w-containerSm md:max-w-container mx-auto">
          {/* Kategoriler */}
          <div className="flex">
            {['all', 'Davam edən', 'Tamamlanmış'].map((category) => (
              <button
                key={category}
                className={`md:px-8 px-6 py-3 md:text-[18px] ${
                  filter === category
                    ? 'bg-[#01A396] text-white'
                    : 'border-b-[1px] border-[#01A396] text-[#1C1C1C]'
                }`}
                onClick={() => handleFilterChange(category)}
              >
                {category === 'all' ? 'Bütün layihələr' : category}
              </button>
            ))}
          </div>
  
          {/* Filtrelenmiş Projeler */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-[88px] md:mt-[64px]">
            {filteredItems.map((item) => (
              <div className="w-full border border-[#E5E5E5] rounded-lg" key={item.id}>
                <img src={item.imgSrc} className="w-full" alt="" />
                <div className="bg-[white] py-4 px-4 rounded-lg">
                  <div className="flex justify-between h-[60px]">
                    <p className="text-[#1C1C1C] text-[18px] md:text-[20px] font-medium">{item.title}</p>
                    <p className="text-[#01A396] h-[29px] px-3 rounded-lg flex items-center text-[14px] bg-[#F6FAFA]">{item.situation}</p>
                  </div>
                  <a className='group' href={`projects/${item?.id}`}>
                    <div className="flex items-center mt-4 justify-between mx-auto md:mx-0 w-[90px] rounded-[12px] bg-white text-[#1C1C1C] h-[46px]">
                    <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                      <img 
                                                                                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                                                      src={rightArrow}
                                                                                                      alt=""
                                                                                                    />
                                                                                                    <img
                                                                                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                                                      src={rightArrowHover}
                                                                                                      alt=""
                                                                                                    />
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  
  export default ProjectsItems;
  